import { Icon } from '@iconify/react';
import CryptoJS from 'crypto-js';
import { useEffect, useState } from 'react';
// material
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// react icons
// material icons
// other icons
import searchFill from '@iconify/icons-eva/search-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { MdAutorenew, MdOutlineAdd, MdPublishedWithChanges } from 'react-icons/md';
import { Cog } from 'lucide-react';

import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
// ----------------------------------------------------------------------

import { CommonApiforJourney } from '../services/RecommendationApi';

import { domainUrl } from '../services/globalApi';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

export default function RecommendationToolbar({
  numSelected,
  filterName,
  setFilterName,
  onFilterName,
  filterDatesRange = [{ startDate: null, endDate: null, key: 'selection' }],
  setFilterDatesRange,
  filterState,
  setFilterState,
  setConvertLead,
  selected,
  setOpenLoader,
  setOpenApiError,
  setErrorMessage
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [showTextfield, setShowTextfield] = useState(false);
  const [openAssign, setOpenAssign] = useState(false);
  const [assignValue, setAssignValue] = useState(' ');
  const [selectProduct, setSelectProduct] = useState(' ');
  const [selectCity, setSelectCity] = useState(' ');
  const [selectStatus, setSelectStatus] = useState(' ');
  const [selectEmployment, setSelectEmployment] = useState(' ');

  const { LoginData } = useLoginSelector();

  useEffect(() => {
    recommendationApiFire('employmentType', null);
    recommendationApiFire('cityList', null);
    recommendationApiFire('productList', null);
    recommendationApiFire('statusList', null);
  }, []);

  const recommendationApiFire = async (type, condition) => {
    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;

    if (type === 'productList') {
      methodName = 'POST';
      endapiPath = 'company/all-loan-masters/list';
      recommendationApiFireResponse(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        ''
      );
    } else if (type === 'statusList') {
      methodName = 'POST';
      endapiPath = 'recommendation/statuses';
      recommendationApiFireResponse(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        ''
      );
    } else if (type === 'employmentType') {
      companyIdObj.returnConfiguredTypesOnly = true;
      methodName = 'POST';
      endapiPath = 'company/parent-emp-types/list';
      recommendationApiFireResponse(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        ''
      );
    } else if (type === 'cityList') {
      companyIdObj.searchLiteral = '';
      companyIdObj.sortOrder = 'desc';
      methodName = 'POST';
      endapiPath = 'sa/cscs/city/list';
      recommendationApiFireResponse(
        type,
        methodName,
        endapiPath,
        JSON.stringify(companyIdObj),
        token,
        ''
      );
    } else if (type === 'Convert to Lead') {
      if (selected.length > 0) {
        selected.forEach((element) => {
          companyIdObj.recommendationId = element.partnerRecommendationId;
          methodName = 'PUT';
          endapiPath = `recommendation/convert`;
          recommendationApiFireResponse(
            type,
            methodName,
            endapiPath,
            JSON.stringify(companyIdObj),
            token,
            ''
          );
        });
      }
    }

    // recommendationApiFireResponse(
    //   type,
    //   methodName,
    //   endapiPath,
    //   JSON.stringify(companyIdObj),
    //   token,
    //   ''
    // );
  };

  const recommendationApiFireResponse = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData
  ) => {
    if (type === 'Convert to Lead') {
      setOpenLoader(true);
    }
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      if (type === 'employmentType') {
        const prevData = filterState;
        prevData.employmentTypeArray = responseData.data.empTypes;
        setFilterState(prevData);
      } else if (type === 'cityList') {
        const prevData = filterState;
        prevData.cityArray = responseData.data;
        setFilterState(prevData);
      } else if (type === 'statusList') {
        const prevData = filterState;
        prevData.statusArray = responseData.data.statuses;
        setFilterState(prevData);
      } else if (type === 'productList') {
        const prevData = filterState;
        prevData.productArray = responseData.data.loanTypes;
        setFilterState(prevData);
      } else if (type === 'Convert to Lead') {
        setOpenLoader(false);
        setConvertLead(true);
      }
    } else {
      setOpenLoader(false);
      setOpenApiError(true);
      setErrorMessage('Something went wrong');
    }
  };

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);

    setFilterState({
      ...filterState,
      product: ' ',
      productId: null,
      city: null,
      cityId: null,
      status: ' ',
      statusId: null,
      employmentType: ' ',
      employmentTypeId: null
    });
    setFilterName('');
  };

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.product}
                onChange={(e) => {
                  const prevData = filterState;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.product = e.target.value;
                  prevData.productId = inputVal.loanId;
                  setFilterState({ ...filterState, prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.product}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Product
                </MenuItem>

                {filterState.productArray.map((productItem, productIndex) => (
                  <MenuItem
                    key={`employmentTypeItem${productIndex}`}
                    value={JSON.stringify(productItem)}
                  >
                    {productItem.loanName}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange?.[0]?.startDate != null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange?.[0]?.endDate != null ? fDate(filterDatesRange[0].endDate) : ''}
                {!filterDatesRange?.[0]?.startDate && !filterDatesRange?.[0]?.endDate ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) =>
                    typeof setFilterDatesRange === 'function' &&
                    setFilterDatesRange([item.selection])
                  }
                  moveRangeOnFirstSelection={false}
                  ranges={
                    filterDatesRange?.length > 0
                      ? filterDatesRange
                      : [{ startDate: null, endDate: null, key: 'selection' }]
                  }
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            <Grid item xs>
              <Autocomplete
                disablePortal
                id="combo-box-demo8"
                options={filterState.cityArray}
                size="small"
                getOptionLabel={(option) => option.cityName}
                renderOption={(props, option) => <li {...props}>{option.cityName}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
                value={filterState.city}
                onChange={(e, newValue) => {
                  const prevData = filterState;
                  prevData.city = newValue;
                  prevData.cityId = newValue.cityId;
                  setFilterState({ ...filterState, prevData });
                }}
              />
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.status}
                onChange={(e) => {
                  const prevData = filterState;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.status = e.target.value;
                  prevData.statusId = inputVal.typeId;
                  setFilterState({ ...filterState, prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.status}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>

                {filterState.statusArray.map((statusItem, statusItemIndex) => (
                  <MenuItem
                    key={`employmentTypeItem${statusItemIndex}`}
                    value={JSON.stringify(statusItem)}
                  >
                    {statusItem.typeName}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                value={filterState.employmentType}
                onChange={(e) => {
                  const prevData = filterState;
                  const inputVal = JSON.parse(e.target.value);
                  prevData.employmentType = e.target.value;
                  prevData.employmentTypeId = inputVal.employmentCategoryId;
                  setFilterState({ ...filterState, prevData });
                }}
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterState.employmentType}`
                }}
              >
                <MenuItem value=" " disabled>
                  Select Employment
                </MenuItem>

                {filterState.employmentTypeArray.map((employmentTypeItem, employmentTypeIndex) => (
                  <MenuItem
                    key={`employmentTypeItem${employmentTypeIndex}`}
                    value={JSON.stringify(employmentTypeItem)}
                  >
                    {employmentTypeItem.employmentCategoryName}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Tooltip title="Add New Recommendation" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => {
                localStorage.removeItem('viewRecommendation');
                const authToken = LoginData?.jwt;
                const companyId = LoginData?.companyId;
                const userId = LoginData?.userId;
                const appToken = CryptoJS.AES.encrypt('null', 'appToken').toString();
                const companyToken = CryptoJS.AES.encrypt(
                  String(companyId),
                  'companyToken'
                ).toString();
                const userToken = CryptoJS.AES.encrypt(authToken, 'userToken').toString();
                const leadToken = CryptoJS.AES.encrypt('null', 'leadToken').toString();
                const userIdToken = CryptoJS.AES.encrypt(String(userId), 'userId').toString();
                window.open(
                  `${domainUrl}recommendation/recommendation-configure?u=${encodeURIComponent(
                    userToken
                  )}&c=${encodeURIComponent(companyToken)}&a=${encodeURIComponent(
                    appToken
                  )}&l=${encodeURIComponent(leadToken)}&ui=${encodeURIComponent(
                    userIdToken
                  )}&applicationCreationEntryPlatform=SALES`,
                  `_blank`
                );
              }}
            >
              <MdOutlineAdd size={18} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title="Convert to Lead"
            placement="top"
            arrow
            onClick={(e) => {
              recommendationApiFire('Convert to Lead', selected);
            }}
          >
            <IconButton
              className="squareIconButton ml-1"
              classes={{ disabled: 'disabledBtn' }}
              disabled={selected && selected.length < 1}
            >
              <MdPublishedWithChanges size={18} />
            </IconButton>
          </Tooltip>
          {/* <Tooltip
            title="Reco Engine"
            placement="top"
            arrow
            onClick={(e) => {
              window.open(`${domainUrl}recommendation/reco-engine-section`);
            }}
          >
            <IconButton className="squareIconButton ml-1">
              <Cog size={18} />
            </IconButton>
          </Tooltip> */}
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Leads"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
    </>
  );
}
